import { Alert } from "@itandi/itandi-bb-ui/Alert";
import type { ReactNode } from "react";
import React from "react";
import { SurveyFormRow } from "~/components/common/survey/SurveyFormRow";
import type { DealSurvey } from "~/models/Survey";
import Styles from "./SurveyForm.module.scss";

type Props = {
	surveys: DealSurvey[];
};
export function SurveyForm({ surveys }: Props) {
	const renderRow = React.useCallback(
		(survey: DealSurvey, index: number): ReactNode => (
			<SurveyFormRow key={survey.id} survey={survey} surveyIndex={index} />
		),
		[]
	);
	if (surveys === null || surveys.length === 0) return null;

	return (
		<div>
			<Alert variant="info">
				今回の工事の評価をお願いします。
				<br />
				※評価の内容は施工会社に共有されます。
			</Alert>
			<div className={Styles.Forms}>{surveys.map(renderRow)}</div>
		</div>
	);
}
